module.exports = __webpack_public_path__ + "static/media/candle_rock.6b0abd3d.jpeg";